// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { ListResourceGps_abstract } from './../abstract/SagaStateLib/ListResourceGps_abstract';
export class ListResourceGps extends ListResourceGps_abstract {}
